import React, { useState, useEffect } from 'react';
import Footer from '../Footer';

const Video = () => {
  const [message, setMessage] = useState("Upcoming Video");

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage((prevMessage) =>
        prevMessage === "Upcoming Video" ? "Stay Tuned, Coming Soon!" : "Upcoming Video"
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Full viewport height
      }}
    >
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* Centered Message */}
        <h2 style={{ textAlign: "center", fontSize: "1.5rem", marginBottom: "20px" }}>
          {message}
        </h2>
      </div>
      {/* Footer at the Bottom */}
      <Footer />
    </div>
  );
};

export default Video;
